import { CSSProperties } from 'react';

interface Props {
  size?: string;
  width?: string;
  height?: string;
  style?: CSSProperties;
}

const Icon = ({ width, height, size, style }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || size || '20'}
      height={height || size || '22'}
      viewBox="0 0 20 22"
      style={style}
    >
      \
      <g fill="none" fillRule="evenodd" stroke="#5B8BF7" strokeLinecap="round" strokeWidth="1.1">
        \
        <path d="M9.976 1.154v19.692M12.988 2.419L10.01 5.397 6.964 2.35M12.988 19.581l-2.978-2.978-3.046 3.046" />
        \
        <g>
          \
          <path d="M1.609 5.772l16.595 9.581M4.156 3.908L5.185 7.75 1.136 8.835M18.545 12.215l-3.842 1.03 1.085 4.049" />
          \
        </g>
        \
        <g>
          \
          <path d="M18.273 5.766L1.678 15.347M18.614 8.904l-3.842-1.03 1.085-4.048M4.225 17.212l1.03-3.842-4.05-1.085" />
          \
        </g>
        \
      </g>
      \
    </svg>
  );
};

export default Icon;
